// Mock content for KD Veterinary Physiotherapy site clone.
// NOTE: Static content lives here; contact form submission is mocked to localStorage
// until backend is wired up.

export const site = {
  name: 'KD Veterinary Physiotherapy',
  phone: '07398 011 049',
  phoneHref: 'tel:+447398011049',
  email: 'kate.d.vetphysio@gmail.com',
  area: 'the West Midlands, Warwickshire & surrounding areas',
  instagram: 'https://www.instagram.com/kd_vetphysio',
  facebook: 'https://www.facebook.com/share/15k5dDbAvm/',
};

export const nav = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  {
    label: 'Services',
    to: '/services',
    children: [
      { label: 'Equine Physiotherapy', to: '/equine-physiotherapy' },
      { label: 'Canine Physiotherapy', to: '/canine-physiotherapy' },
      { label: 'Rehabilitation / Class 4 Laser', to: '/canine-hydrotherapy' },
      { label: 'Cats & Small Animals', to: '/cats-small-animals' },
    ],
  },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Contact', to: '/contact' },
];

export const hero = {
  eyebrow: 'Equine · Canine · Feline',
  title: 'KD Veterinary Physiotherapy',
  subtitle: '',
  cta: 'Book your appointment now',
  image: '/photos/hero.jpg',
  intro: [
    'Kate Darlison is a fully qualified and insured veterinary physiotherapist, registered with the National Association of Veterinary Physiotherapists (NAVP). KD Veterinary Physiotherapy works to improve mobility, maintain comfort and ensure the ongoing quality of life of equines, canines and other family pets across the West Midlands, Warwickshire and surrounding areas.',
    'Kate works closely alongside vets, trainers and farriers as part of a multi-disciplinary team to help optimise performance and support recovery, with every treatment plan tailored to the individual animal.',
  ],
};

export const badges = [
  { icon: 'Award', label: 'NAVP Registered' },
  { icon: 'ShieldCheck', label: 'Fully Insured' },
  { icon: 'Star', label: '5 Star Reviews' },
  { icon: 'Zap', label: 'Class 4 Laser' },
  { icon: 'HeartPulse', label: 'Vet Recommended' },
  { icon: 'Trophy', label: 'Performance Care' },
];

export const services = {
  eyebrow: 'What we do',
  title: 'Our Physiotherapy Services',
  subtitle: 'A full range of manual and electrotherapy treatments for equines, canines and other family pets.',
  note: 'Every treatment plan is bespoke to the individual animal. Please note that prior to an initial consultation, veterinarian consent is required – contact Kate who will advise on the process for registering as a KD Veterinary Physiotherapy client.',
  items: [
    {
      icon: 'HeartPulse',
      title: 'Rehabilitation Programmes',
      text: 'KD Veterinary Physiotherapy can work with you to develop tailored rehabilitation plans as part of your animal’s ongoing recovery, with achievable exercises to do between sessions.',
      to: '/canine-hydrotherapy',
    },
    {
      icon: 'Zap',
      title: 'Class 4 Laser Therapy',
      text: 'Access to the latest Class 4 Laser technology, which delivers energy to damaged tissues, stimulating cellular function and increasing circulation – improving recovery times.',
      to: '/canine-hydrotherapy',
    },
    {
      icon: 'Hand',
      title: 'Massage & Manual Therapy',
      text: 'Massage is the basis of any physiotherapy session, using a range of techniques to improve tissue hydration and tone. Sessions may also incorporate myofascial release to work on the fascia, acupressure along neural and myofascial pathways, and visceral & craniosacral techniques to promote relaxation, circulation and the body’s natural healing.',
      to: '/services',
    },
  ],
};

export const reviews = {
  eyebrow: 'Testimonials',
  title: "You're in great hands",
  subtitle: 'Kind words from the owners and yards we work with.',
  items: [
    {
      quote:
        'Kate is very professional and quiet with the horses. They all respond really well to her and the treatments have had a profound effect on them. Kate has made a huge difference to their wellbeing and Knowle Racing highly recommends her.',
      author: 'Knowle Racing',
    },
    {
      quote:
        'Kate has been amazing with my old boy. His mobility has improved so much since she started treating him and he is so much more comfortable. I can’t thank her enough.',
      author: 'Sarah H.',
    },
    {
      quote:
        'My agility dog is back to full fitness after his injury thanks to Kate’s rehab programme. She explained everything clearly and gave me exercises to do at home. Brilliant service.',
      author: 'Tom B.',
    },
    {
      quote:
        'Professional, knowledgeable and so gentle with our nervous mare. We’ve seen a real difference in her movement and attitude under saddle. Highly recommend.',
      author: 'Emma J.',
    },
    {
      quote:
        'Kate treated our Labrador after cruciate surgery and the recovery has been fantastic. The laser therapy and home plan made all the difference. Thank you, Kate!',
      author: 'Rebecca C.',
    },
  ],
};

export const aboutPhysio = {
  title: 'About Veterinary Physiotherapy',
  paragraphs: [
    'Veterinary physiotherapy is often used as part of an animal’s comprehensive health routine, alongside conventional medicine. Supported by scientific research, veterinary physiotherapy benefits a wide variety of musculoskeletal and neurological conditions, including poor performance and pre- and post-surgery.',
    'At KD Veterinary Physiotherapy, Kate provides tailored treatments for horses, dogs and other family pets. Clients include performance and racing horses, working or agility dogs and much-loved companion animals. Treatment takes place in the animal’s own environment, on the yard, or during competition.',
    'Treatment modalities include manual therapy such as massage, stretching, joint mobilisations and myofascial release, alongside electrotherapies including Class 4 LASER, acupressure and visceral & craniosacral techniques.',
    'Electrotherapies are key in supporting manual treatment and can be used to provide pain relief, assist with tissue repair, reduce swelling and aid neurological regeneration. Treatment plans and remedial exercise programmes are tailored to the individual patient ensuring practicality and achievability.',
  ],
};

export const meetKate = {
  eyebrow: 'Meet Kate',
  title: 'Meet Kate',
  intro:
    'KD Veterinary Physiotherapy is run by Kate Darlison, who is dedicated to using her skills and experience to achieve the best results for you and your animal.',
  image: '/photos/kate.jpg',
  name: 'Kate Darlison',
  role: 'Veterinary Physiotherapist',
  creds: 'NAVP Registered · Fully Qualified & Insured',
  bio: 'Kate is a fully qualified and insured, NAVP-registered veterinary physiotherapist serving the West Midlands, Warwickshire and surrounding areas. Her experience includes rehabilitating horses at an equine swimming centre, monitoring individual cases and delivering strength & conditioning programmes for competition horses. Kate is also the lead equine physiotherapist on a racing yard, working alongside vets, trainers and farriers to optimise performance and secure results – often out on the road with her black Labrador, Billy.',
};

export const gallery = {
  eyebrow: 'In the field',
  title: 'Kate at Work',
  subtitle: 'A glimpse of treatments in action – from laser therapy and massage to hands-on equine and canine rehabilitation.',
  images: [
    { src: '/photos/kw1.jpg', alt: 'Kate assessing a horse on the yard' },
    { src: '/photos/kw4.jpg', alt: 'Canine physiotherapy for a dog at home' },
    { src: '/photos/kw2.jpg', alt: 'Kate with one of her equine patients' },
    { src: '/photos/kw5.jpg', alt: 'Kate treating a large-breed dog' },
    { src: '/photos/kw3.jpg', alt: 'Equine physiotherapy session on the yard' },
    { src: '/photos/g1.jpg', alt: 'Class 4 laser therapy on a dog' },
    { src: '/photos/g8.jpg', alt: 'Equine physiotherapy outdoors' },
    { src: '/photos/g6.jpg', alt: 'Laser therapy detail' },
  ],
};

export const recovery = {
  eyebrow: 'Recovery Stories',
  title: 'Real Progress, Real Results',
  subtitle: 'Drag the slider on each photo to see the difference physiotherapy has made. Every animal is different – these are a few of the journeys Kate has supported.',
  items: [
    {
      before: '/photos/g4.jpg',
      after: '/photos/g1.jpg',
      tag: 'Maggie · Labrador',
      title: 'Back stronger after cruciate surgery',
      text: 'A structured rehabilitation programme with laser and home exercises rebuilt Maggie’s strength after cruciate repair – now enjoying long walks and play, pain-free.',
    },
    {
      before: '/photos/g3.jpg',
      after: '/photos/g6.jpg',
      tag: 'Competition Horse',
      title: 'Restored suppleness for the season',
      text: 'Regular massage and myofascial release relieved recurring back tension, improving range of motion and helping this eventer stay comfortable and competitive.',
    },
    {
      before: '/photos/g5.jpg',
      after: '/photos/g7.jpg',
      tag: 'Oscar · Boxer',
      title: 'Comfortable on his feet again',
      text: 'A course of Class 4 laser therapy alongside gentle physiotherapy dramatically improved Oscar’s mobility and comfort, easing the effects of arthritis.',
    },
  ],
};

export const benefits = {
  title: 'Benefits of using a veterinary physiotherapist',
  intro: 'Veterinary physiotherapists are trained to provide specialist treatments for animals to aid pain management, minimise the risk of injury, improve mobility and flexibility, support injury recovery, and enhance performance.',
  items: [
    {
      title: 'Performance',
      image: 'https://images.unsplash.com/photo-1512934772407-b292436089ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
      text: 'For sports or working animals, being in top physical condition is essential to allowing them to reach their best athletic potential. We work with many elite sports horses and dogs to improve and maintain performance.',
    },
    {
      title: 'Preventative',
      image: 'https://images.unsplash.com/photo-1597595735781-6a57fb8e3e3d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
      text: 'Veterinary physiotherapy can enhance the animal’s wellbeing and provide preventative care. All animals can benefit from the positive effects of massage and other therapeutic techniques. Small changes can dramatically enhance range of motion and muscle tone; developing strength to help in the prevention of injury.',
    },
    {
      title: 'Recovery',
      image: 'https://images.unsplash.com/photo-1534361960057-19889db9621e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
      text: 'Following injury or surgery, treatment by a veterinary physiotherapist can form an integral part of recovery, helping to reduce pain levels and introduce a return to functional activity. We work closely with referring veterinary surgeons to ensure a return to full function and normal activity.',
    },
  ],
};

export const pricing = {
  eyebrow: 'Pricing',
  title: 'Treatment Pricing',
  subtitle: 'Transparent, per-session pricing. Every plan is tailored to your animal.',
  items: [
    { animal: 'Horses / Equine', price: '£65', unit: 'per session', icon: 'Horse' },
    { animal: 'Dogs / Canine', price: '£60', unit: 'per session', icon: 'Dog' },
    { animal: 'Cats & Small Animals', price: '£55', unit: 'per session', icon: 'Cat' },
    { animal: 'Class 4 Laser', price: '£45', unit: 'per session', icon: 'Zap' },
  ],
  rehabNote: 'Rehabilitation programmes are included in the physiotherapy session price.',
  travel: 'Travel is free within 15 miles of Pillerton Hersey. Beyond this, a charge of 50p per mile applies. Kate covers approximately a 50-mile radius across the West Midlands, Warwickshire and surrounding areas.',
};

export const faqs = {
  title: 'Frequently Asked Questions',
  intro: 'If you have any other questions or would like to discuss our treatment options, please contact us.',
  items: [
    {
      q: 'Do I need a referral from my vet?',
      a: 'If your animal is currently being treated by a vet for lameness or poor performance, veterinary consent is required. Veterinary consent is not required for maintenance or competition care if the animal is fit, sound and healthy.',
    },
    {
      q: 'Is veterinary physiotherapy covered by insurance?',
      a: 'Many pet and equine insurance policies cover veterinary physiotherapy when carried out on referral from your vet. We recommend checking the terms of your individual policy, and Kate is happy to provide receipts and treatment notes to support any claim.',
    },
    {
      q: 'What does a veterinary physiotherapy session involve?',
      a: 'A first session includes a full history, static and dynamic assessment, and gait analysis, followed by a bespoke treatment using manual therapy and electrotherapies as appropriate. Kate will then provide a tailored home exercise programme and agree a follow-up plan.',
    },
    {
      q: 'Why use veterinary physiotherapy?',
      a: 'Physiotherapy helps manage pain, improve mobility and flexibility, reduce the risk of injury, support recovery after surgery or injury, and enhance athletic performance – all tailored to the individual animal.',
    },
    {
      q: 'What is veterinary physiotherapy?',
      a: 'Veterinary physiotherapy is the assessment and treatment of musculoskeletal and neurological conditions in animals using manual therapies and electrotherapies, working alongside conventional veterinary medicine as part of a multi-disciplinary approach.',
    },
  ],
};

export const arranging = {
  title: 'Arranging an appointment',
  paragraphs: [
    'If you think your animal will benefit from veterinary physiotherapy or hydrotherapy, or would like more information about how we could help you, please get in touch.',
    'If your animal is currently receiving veterinary treatment or is injured, you may need veterinary consent or referral, but we can discuss the necessary requirements for this with you.',
    'Our team is skilled and caring and will work to help reduce pain, improve performance, support rehabilitation and determine a personalised plan to best suit the animal and owner.',
  ],
  image: '/photos/hydro.jpg',
};

export const contactCta = {
  title: 'To book an appointment or discuss treatment options for your animal',
  text: 'Call Kate on 07398 011 049 or click the button to fill in your details. We will get back to you as soon as possible.',
};

// Inner service pages
export const servicePages = {
  'equine-physiotherapy': {
    eyebrow: 'Equine',
    title: 'Equine Physiotherapy',
    hero: '/photos/g8.jpg',
    lead: 'Specialist physiotherapy for performance, racing and leisure horses – delivered in your own yard.',
    sections: [
      {
        heading: 'Tailored care for every horse',
        body: 'From elite eventers and racehorses to much-loved companions, Kate provides bespoke equine physiotherapy to improve mobility, maintain comfort and optimise performance. As lead physiotherapist on a racing yard, she works closely alongside vets, trainers and farriers as part of a multi-disciplinary team.',
      },
      {
        heading: 'What treatment involves',
        body: 'A full static and dynamic assessment, including gait analysis, informs a treatment plan combining manual therapy – massage, stretching and joint mobilisations – with electrotherapies such as Class 4 LASER, acupressure and myofascial release. Kate also provides remedial exercise programmes to complete between sessions.',
      },
      {
        heading: 'Performance & prevention',
        body: 'Regular physiotherapy helps keep competition horses supple and sound, reduces the risk of injury and supports a swift, structured return to work following injury or surgery.',
      },
    ],
  },
  'canine-physiotherapy': {
    eyebrow: 'Canine',
    title: 'Canine Physiotherapy',
    hero: '/photos/g1.jpg',
    lead: 'Physiotherapy and rehabilitation for working dogs, agility athletes and family companions.',
    sections: [
      {
        heading: 'Helping dogs move comfortably',
        body: 'Whether your dog is a working or agility athlete or a beloved family pet, physiotherapy can improve mobility, ease pain and support recovery. Kate tailors every plan to the individual dog and the goals of the owner.',
      },
      {
        heading: 'Conditions we help with',
        body: 'Common cases include post-operative rehabilitation (such as cruciate repair), arthritis and age-related stiffness, soft-tissue injury, and conditioning for sporting dogs. Treatment combines manual therapy with Class 4 LASER and home exercise programmes.',
      },
      {
        heading: 'Treatment in the home',
        body: 'Sessions take place in your dog’s own environment, keeping them relaxed and comfortable, with clear guidance on exercises to continue between visits.',
      },
    ],
  },
  'canine-hydrotherapy': {
    eyebrow: 'Rehabilitation',
    title: 'Rehabilitation & Class 4 Laser',
    hero: '/photos/g6.jpg',
    lead: 'Structured rehabilitation programmes supported by the latest Class 4 Laser technology.',
    sections: [
      {
        heading: 'Rehabilitation programmes',
        body: 'Following injury or surgery, a structured rehabilitation plan is essential to a full recovery. Kate develops achievable, progressive programmes with exercises to complete between sessions, working closely with your referring vet throughout.',
      },
      {
        heading: 'Class 4 Laser therapy',
        body: 'Access to the latest Class 4 Laser technology, which delivers energy to damaged tissues, stimulating cellular function and increasing circulation. This helps to reduce pain and inflammation, accelerate tissue repair and improve recovery times.',
      },
      {
        heading: 'A collaborative approach',
        body: 'Rehabilitation is most effective as part of a multi-disciplinary team. Kate liaises with vets, trainers and owners to ensure a safe, effective return to full function and normal activity.',
      },
    ],
  },
  'cats-small-animals': {
    eyebrow: 'Cats & Small Animals',
    title: 'Cats & Small Animals',
    hero: '/photos/g7.jpg',
    lead: 'Gentle, tailored physiotherapy for cats and other much-loved family pets.',
    sections: [
      {
        heading: 'Gentle, patient care',
        body: 'Cats and small animals benefit from physiotherapy just as much as horses and dogs. Kate uses gentle, low-stress techniques to help manage pain, improve mobility and support wellbeing, always at the animal’s own pace.',
      },
      {
        heading: 'How we can help',
        body: 'Physiotherapy can support older animals with arthritis and stiffness, aid recovery after injury or surgery, and improve comfort and quality of life. Every plan is tailored to the individual animal and carried out in familiar surroundings.',
      },
      {
        heading: 'Working with your vet',
        body: 'Where your animal is under veterinary care, Kate will obtain veterinary consent and work alongside your vet to ensure treatment is safe and appropriate.',
      },
    ],
  },
};

export const animalTypes = ['Horse / Equine', 'Dog / Canine', 'Cat', 'Other small animal'];
